import { render } from "./professionalType.vue?vue&type=template&id=3f8f8c8b&scoped=true"
import script from "./professionalType.vue?vue&type=script&lang=js"
export * from "./professionalType.vue?vue&type=script&lang=js"

import "./professionalType.vue?vue&type=style&index=0&id=3f8f8c8b&scoped=true&lang=css"
import "./professionalType.vue?vue&type=style&index=1&id=3f8f8c8b&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f8f8c8b"]])

export default __exports__